import { render, staticRenderFns } from "./DiffViewer.vue?vue&type=template&id=7a9f3b7b&"
import script from "./DiffViewer.vue?vue&type=script&lang=js&"
export * from "./DiffViewer.vue?vue&type=script&lang=js&"
import style0 from "./DiffViewer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
